import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ChangeEvent, useEffect, useState, Dispatch } from 'react';
import DaumPostcode from 'react-daum-postcode';

const columns = ['도서 제목', '출판사', '저자'];

interface Props {
  open: boolean;
  onClose: () => void;
  bookList: any[];
}

export const SwBookList: React.FC<Props> = ({ open, onClose, bookList }) => {
  const [requestList, setRequestList] = useState<any>([]);
  const [bookSeq, setBookSeq] = useState<number>(-1);

  useEffect(() => {
    if (open && bookList) {
      const newData = bookList.map((item: any) => [
        item.title,
        item.publisher,
        item.author,
      ]);
      setRequestList(newData);
    } else {
      setRequestList([]);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          minHeight: '52vh',
          minWidth: '44vw',
        },
      }}
    >
      <DialogTitle>
        <Box className='flex_between'>
          <Typography className='title'>도서 상세보기</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider sx={{ m: 0, p: 0 }} />
      <DialogContent>
        <TableContainer sx={{ height: '50vh', overflowY: 'scroll' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((column: any, idx: number) => (
                  <TableCell key={idx.toString()} sx={{ p: '.4rem .7rem' }}>
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {requestList.length > 0 &&
                requestList.map((row: any, idx: number) => (
                  <TableRow key={`book_row_key_${idx}`}>
                    {columns.map((item: any, index: number) => (
                      <TableCell
                        key={`book_col_key+${index}`}
                        sx={{ p: '.7rem' }}
                      >
                        {row[index]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};
